import { render, staticRenderFns } from "./enterpriseProfile2.vue?vue&type=template&id=322ebcb0"
import script from "./enterpriseProfile2.vue?vue&type=script&lang=js"
export * from "./enterpriseProfile2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports